import type { ReactNode } from 'react';

import { STATUS_COLORS, type ExamSlice } from './examResults';

const DONUT_RADIUS = 30;
const DONUT_BOX = 76;
const DONUT_CENTRE = DONUT_BOX / 2;
const DONUT_CIRCUMFERENCE = 2 * Math.PI * DONUT_RADIUS;

/** Hand-rolled multi-slice doughnut; the repo carries no chart library. */
function Donut({ slices }: { slices: ExamSlice[] }) {
  const total = slices.reduce((sum, slice) => sum + slice.count, 0);
  const drawn = total > 0 ? slices.filter((slice) => slice.count > 0) : [{ title: 'Chưa có dữ liệu', count: 1, color: STATUS_COLORS.idle }];
  const span = total > 0 ? total : 1;
  let consumed = 0;
  return (
    <svg className="quiz-results__donut-svg" width={DONUT_BOX} height={DONUT_BOX} viewBox={`0 0 ${DONUT_BOX} ${DONUT_BOX}`} aria-hidden={true}>
      {drawn.map((slice) => {
        const length = (DONUT_CIRCUMFERENCE * slice.count) / span;
        const offset = consumed;
        consumed += length;
        return <circle key={slice.title} cx={DONUT_CENTRE} cy={DONUT_CENTRE} r={DONUT_RADIUS} fill="none" stroke={slice.color} strokeWidth="9" strokeDasharray={`${length} ${DONUT_CIRCUMFERENCE - length}`} strokeDashoffset={-offset} transform={`rotate(-90 ${DONUT_CENTRE} ${DONUT_CENTRE})`} />;
      })}
    </svg>
  );
}

/** `centre` sits in the ring's hole, e.g. the average score. */
export function DonutRow({ slices, centre }: { slices: ExamSlice[]; centre?: ReactNode }) {
  return (
    <div className="quiz-results__donut-row">
      <div className="quiz-results__donut"><Donut slices={slices} />{centre ? <div className="quiz-results__donut-centre">{centre}</div> : null}</div>
      <ul className="quiz-results__legend">
        {slices.filter((slice) => slice.count > 0).map((slice) => (
          <li key={slice.title} className="quiz-results__legend-row">
            <span className="quiz-results__legend-dot" style={{ background: slice.color }} />
            <span className="quiz-results__legend-title">{slice.title}</span>
            <span className="quiz-results__legend-count">{slice.count}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

/** "4 học sinh / 5" over a meter: anonymous, so it shows while projected. */
export function SubmittedMeter({ submitted, total }: { submitted: number; total: number }) {
  return (
    <section className="quiz-results__block">
      <h3 className="quiz-results__block-title">Số học sinh đã nộp bài</h3>
      <p className="quiz-results__stat">
        <span className="quiz-results__stat-value">{submitted} học sinh</span>
        <span className="quiz-results__stat-total"> / {total}</span>
      </p>
      <div className="quiz-results__meter">
        <span className="quiz-results__meter-fill" style={{ width: `${total > 0 ? Math.round((submitted / total) * 100) : 0}%` }} />
      </div>
    </section>
  );
}
